import { useEffect, useState } from 'react'
import { AppHeader, type Theme } from './components/AppHeader'
import { LandingPage } from './components/LandingPage'
import { Workspace } from './components/workspace/Workspace'
import type { WorkflowStep } from './components/workspace/StepRail'
import { useBoqWorkspace } from './hooks/useBoqWorkspace'

type AppMode = 'home' | 'workspace'

function initialTheme(): Theme {
  const saved = localStorage.getItem('boq-diff:theme')
  if (saved === 'light' || saved === 'dark') return saved
  return 'light'
}

export default function App() {
  const workspace = useBoqWorkspace()
  const [mode, setMode] = useState<AppMode>('home')
  const [initialStep, setInitialStep] = useState<WorkflowStep>(1)
  const [theme, setTheme] = useState<Theme>(initialTheme)

  useEffect(() => {
    document.documentElement.dataset.theme = theme
    localStorage.setItem('boq-diff:theme', theme)
  }, [theme])

  const start = (): void => {
    setInitialStep(1)
    setMode('workspace')
  }

  const loadDemo = (): void => {
    workspace.loadDemo()
    setInitialStep(2)
    setMode('workspace')
  }

  if (mode === 'home') {
    return (
      <>
        <AppHeader theme={theme} onThemeChange={setTheme} />
        <LandingPage onStart={start} onLoadDemo={loadDemo} />
      </>
    )
  }

  return (
    <div className="workspace-app">
      <AppHeader compact theme={theme} onThemeChange={setTheme} onHome={() => setMode('home')} />
      <Workspace initialStep={initialStep} workspace={workspace} />
    </div>
  )
}
